/* Expand the header search launcher into the existing Horizon search dialog.
   The actual dialog keyboard and focus behaviour remains controlled by Horizon. */
function initLoftySearchExpansion() {
  const dialog = document.querySelector('#search-modal dialog');
  if (!dialog || dialog.dataset.lcExpandInitialised === 'true') return;
  dialog.dataset.lcExpandInitialised = 'true';

  let origin = null;
  let resetId = 0;
  const observer = new MutationObserver(() => {
    if (!dialog.open || !origin) return;
    const from = origin;
    origin = null;
    if (window.matchMedia('(max-width: 749px), (prefers-reduced-motion: reduce)').matches) return;
    const to = dialog.getBoundingClientRect();
    if (!to.width || !to.height || !from.width || !from.height) return;

    const scaleX = Math.min(1, Math.max(0.1, from.width / to.width));
    const scaleY = Math.min(1, Math.max(0.075, from.height / to.height));
    dialog.style.setProperty('--lc-search-origin-x', (from.left - to.left) + 'px');
    dialog.style.setProperty('--lc-search-origin-y', (from.top - to.top) + 'px');
    dialog.style.setProperty('--lc-search-scale-x', String(scaleX));
    dialog.style.setProperty('--lc-search-scale-y', String(scaleY));
    dialog.classList.remove('lc-search-enter');
    dialog.classList.add('lc-search-enter');
    clearTimeout(resetId);
    resetId = window.setTimeout(() => {
      dialog.classList.remove('lc-search-enter');
    }, 350);
  });
  observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });

  const attachTriggers = () => {
    document.querySelectorAll('.lc-header-search--field .lc-header-search__trigger').forEach(button => {
      if (button.dataset.lcExpandAttached === 'true') return;
      button.dataset.lcExpandAttached = 'true';
      button.addEventListener('click', () => {
        origin = button.getBoundingClientRect();
      });
    });
  };
  attachTriggers();
  document.addEventListener('shopify:section:load', attachTriggers);
  dialog.addEventListener('close', () => {
    origin = null;
    clearTimeout(resetId);
    dialog.classList.remove('lc-search-enter');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoftySearchExpansion, { once: true });
} else {
  initLoftySearchExpansion();
}
